type MobileAppDataModel = {
  venue: {
    name: string
    websiteText: string
    websiteUrl: string
  }
  color: {
    primary: string
    secondary: string
    tertiary: string
    background: string
  }
}

enum QUERY {
  MOBILE_APP_DATA = 'mobileAppData'
}

export { QUERY }
export type { MobileAppDataModel }
